/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { Button } from "@forge/common";
import "./Title.scss";
import { useState } from "react";
interface iProps {
  title: string;
  className: string;
  buttonRequired?: boolean;
}

const Title = (props: iProps) => {
  const [showButton, setShowButton] = useState(props.buttonRequired);
  return (
    <div
      className={`d-flex align-items-center justify-items-between ${props.className}`}
    >
      <h3 className="emphasis-1">{props.title}</h3>
      {showButton && <Button variant="primary">Create Tenant</Button>}
    </div>
  );
};
export default Title;
